import script from "./AssinarContrato.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssinarContrato.vue?vue&type=script&lang=ts&setup=true"

import "./AssinarContrato.vue?vue&type=style&index=0&id=5f949c02&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f949c02"]])

export default __exports__